import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=68bc60b0&"
import script from "./buyer.vue?vue&type=script&lang=js&"
export * from "./buyer.vue?vue&type=script&lang=js&"
import style0 from "./buyer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports